module.exports = __webpack_public_path__ + "img/minip_app_image_scan@2x.a5a4a83d.png";